import cx from 'classnames';
import PropTypes from 'prop-types';
import AppBar from '../app-bar';
import Toolbar from '../toolbar';

import styles from './styles.module.scss';

const GlobalBarItems = ({ children, className }) => (
    <div className={cx(className, styles.globalBarItems)}>{children}</div>
);

GlobalBarItems.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};

GlobalBarItems.defaultProps = {
    className: null
};

export const GlobalBarItem = ({ children, active, className }) => (
    <nav
        className={cx(
            styles.globalBarNavItem,
            active && styles.active,
            className
        )}
    >
        {children}
    </nav>
);

GlobalBarItem.propTypes = {
    children: PropTypes.node.isRequired,
    active: PropTypes.bool,
    className: PropTypes.string
};

GlobalBarItem.defaultProps = {
    active: false,
    className: null
};

export const GlobalBar = ({
    logo,
    leftItems,
    centerItems,
    rightItems,
    profileMenu,
    topBanners
}) => {
    const topBannersKeys = Object.keys(topBanners);
    const bannerStyles = topBannersKeys
        .map(bannerName => styles[`withTopBanner${bannerName}`])
        .join(' ');

    return (
        <>
            <div className={styles.topBanners}>{Object.values(topBanners)}</div>
            <AppBar
                position="fixed"
                elevation={0}
                className={cx('Appbar', bannerStyles)}
            >
                <Toolbar className={styles.toolbar}>
                    <GlobalBarItems className={styles.left}>
                        {logo && (
                            <GlobalBarItem className={styles.logo}>
                                {/* TODO: maybe we might want to make a separate component, so spacing is consistent. */}
                                {logo}
                            </GlobalBarItem>
                        )}
                        {leftItems}
                    </GlobalBarItems>
                    {centerItems && (
                        <GlobalBarItems>{centerItems}</GlobalBarItems>
                    )}
                    <GlobalBarItems className={styles.right}>
                        {rightItems}
                        {profileMenu}
                    </GlobalBarItems>
                </Toolbar>
            </AppBar>
        </>
    );
};

GlobalBar.propTypes = {
    logo: PropTypes.node,
    leftItems: PropTypes.node,
    centerItems: PropTypes.node,
    rightItems: PropTypes.node,
    profileMenu: PropTypes.node,
    topBanners: PropTypes.objectOf(PropTypes.node)
};

GlobalBar.defaultProps = {
    logo: null,
    leftItems: null,
    centerItems: null,
    rightItems: null,
    profileMenu: null,
    topBanners: []
};
